export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";